import { REFORGE_LOGO_SRC, REFORGE_POWERED_BY } from '../lib/config';

export function AppFooter({ compact = false }: { compact?: boolean }) {
  return (
    <footer
      className={`border-t border-ink-100 bg-white ${compact ? 'app-footer-compact py-3' : 'py-4'}`}
      role="contentinfo"
    >
      <div className="mx-auto flex max-w-[90rem] flex-wrap items-center justify-center gap-3 px-4 sm:justify-between">
        <p className="text-center text-xs font-medium tracking-wide text-[#002D62] sm:text-left">
          {REFORGE_POWERED_BY}
        </p>
        <img
          src={REFORGE_LOGO_SRC}
          alt="Reforge Tech"
          className={`w-auto object-contain ${compact ? 'h-8' : 'h-10'}`}
          loading="lazy"
          decoding="async"
        />
      </div>
    </footer>
  );
}
